import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

export interface ILetContext<T> {
  $implicit: T; // This allows the use of "as syntax" in the template
  ifLet: T;
}

@Directive({
  selector: '[ifLet]',
})
export class LetDirective<T> {
  private _context: ILetContext<T> = { $implicit: null, ifLet: null };

  @Input() public set ifLet(value: T) {
    this._context.$implicit = value;
    this._context.ifLet = value;
  }

  constructor(
    private _viewContainer: ViewContainerRef,
    private _templateRef: TemplateRef<ILetContext<T>>
  ) {}

  public ngOnInit(): void {
    this._viewContainer.createEmbeddedView(this._templateRef, this._context);
  }
}
